// extracted by mini-css-extract-plugin
export var closeButton = "_gy-1";
export var closeX = "_gy-3";
export var container = "_gy-0";
export var image = "_gy-2";